import P from "@mui/icons-material/Add";
import T from "@mui/icons-material/Remove";
import { styled as c, Button as j, Box as y } from "@mui/material";
import { noForwardProps as A } from "../../temp-lib/util/styled/index.js";
import v from "./ApeironNumberTextField.js";
import * as p from "ramda";
import { useMemo as B, useCallback as x, useEffect as m } from "react";
import { useForm as H, useWatch as I } from "react-hook-form";
import { jsxs as R, jsx as a } from "react/jsx-runtime";
const e = "counter", S = c("form")`
  align-items: center;
  display: flex;
  gap: 10px;
  justify-content: center;
`, h = c(j, A)`
  background-color: black;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  min-width: unset;
  color: #ffffffcc;
  :disabled {
    background-color: black;
    color: #333333;
  }

  &.Custom-Min,
  &.Custom-Max {
    font-size: 12px;
  }
`, z = c(v)`
  .MuiFormHelperText-root {
    bottom: -20px;
    position: absolute;
    width: 100%;
    text-align: center;
  }
`, O = (b) => {
  const {
    className: N,
    defaultValue: g,
    maxValue: i,
    minValue: l,
    remark: C,
    value: s,
    onChange: V,
    onValidate: F
  } = b, {
    control: u,
    formState: k,
    setValue: t,
    trigger: r
  } = H({
    defaultValues: {
      counter: g
    },
    mode: "onChange"
  }), {
    errors: d
  } = k, f = I({
    name: e,
    control: u
  }), o = B(() => {
    const n = Number(f);
    return isNaN(n) ? -1 : n;
  }, [f]), w = x(() => {
    const n = Math.max(l, o - 1);
    t(e, n), r(e);
  }, [l, o, t, r]), M = x(() => {
    const n = Math.min(i, o + 1);
    t(e, n), r(e);
  }, [i, o, t, r]);
  return m(() => {
    F(p.isNil(d.counter));
  }, [d.counter]), m(() => {
    p.isNotNil(s) && s !== o && (t(e, s), r(e));
  }, [s, t, r]), m(() => {
    o !== s && V(o);
  }, [o, t, r]), /* @__PURE__ */ R(S, {
    className: N,
    children: [/* @__PURE__ */ a(h, {
      className: "Custom-Minus",
      onClick: w,
      disabled: o === l,
      children: /* @__PURE__ */ a(T, {})
    }), /* @__PURE__ */ a(z, {
      control: u,
      max: i,
      min: l,
      name: e,
      wholeNumber: !0,
      remark: C,
      FormHelperTextProps: {
        component: y
      }
    }), /* @__PURE__ */ a(h, {
      className: "Custom-Plus",
      onClick: M,
      disabled: o === i,
      children: /* @__PURE__ */ a(P, {})
    })]
  });
};
export {
  O as default
};
//# sourceMappingURL=ApeironCounter.js.map
